export const GRAPHQL_VARIABLES = {};

export const QUERY = `
    query whoami {
        whoami {
            firstName
            lastName
            companyIds
            jobTitle
            defaultCompany
            email
            bookipiUser
            googleId
            appleId
            phoneNumber
            language
            timezone
            hasSignature
            verified
            lastLoginAt
            locale
            _id
            updatedAt
            createdAt
            hash
            salt
            isPhoneVerified
            phoneCountryCode
            companies {
                individuals {
                  _id
                  title
                  birth
                  firstName
                  lastName
                  email
                  ssn
                  phone
                  ownership
                }
                name
                address {
                    address1
                    address2
                    address3
                    state
                    city
                    zip
                    country
                    _id
                }
                email
                bookipiCompany
                phoneNumber
                website
                websiteType
                businessType
                businessName
                description
                ABN
                ACN
                ein
                industry
                bankDetails {
                    bankName
                    accountName
                    accountNo
                    routingNumber
                    accountType
                    ownershipType
                }
                individuals{
                  documentType
                  licenceNumber
                  jurisdiction
                  additionalDocumentType
                  country
                  title
                  birth
                  firstName
                  lastName
                  ownership
                  address {
                    address1
                    address2
                    address3
                    state
                    city
                    zip
                    country
                    _id
                  }
                  email
                  phone
                  _id
                  companyId
                  roles
                  enableDLBackSide
                  driverLicence { url contentType }
                  passport { url contentType }
                  utilityBill { url contentType }
                }
                monthlyCardValue
                monthlyTransactions
                annualTurnover
                highestSalesAmount
                annualCreditTurnover
                serviceDeliveryDays
                categoryCode
                averageSalesAmount
                averageDeliveryTime
                isFzMerchant
                isGlobalPayMerchant
                isStripeMerchant
                stripeAccount
                hasSignature
                verified
                currency
                owner
                _id
                updatedAt
                createdAt
                individuals{
                  documentType
                  licenceNumber
                  jurisdiction
                  additionalDocumentType
                  country
                  title
                  birth
                  firstName
                  lastName
                  ownership
                  address {
                    address1
                    address2
                    address3
                    state
                    city
                    zip
                    country
                    _id
                  }
                  email
                  phone
                  _id
                  companyId
                  roles
                  driverLicence { url contentType }
                  passport { url contentType }
                  utilityBill { url contentType }
                }
                monthlyCardValue
                monthlyTransactions
                annualTurnover
                highestSalesAmount
                annualCreditTurnover
                serviceDeliveryDays
                categoryCode
                averageSalesAmount
                averageDeliveryTime
                isFzMerchant
                isGlobalPayMerchant
                isStripeMerchant
                stripeAccount
                hasSignature
                verified
                currency
                owner
                _id
                updatedAt
                createdAt
                members {
                    firstName
                    lastName
                    companyIds
                    jobTitle
                    defaultCompany
                    email
                    bookipiUser
                    googleId
                    appleId
                    phoneNumber
                    language
                    timezone
                    hasSignature
                    verified
                    lastLoginAt
                    locale
                    _id
                    updatedAt
                    createdAt
                    hash
                    salt
                }
                roles {
                    _id
                    name
                    permissions
                    users
                }
                bankStatement{ url contentType}
                fatzebra{ onboardingStep onboardStartDate onboardNextNotification }
                globalPay{ onboardingStep onboardStartDate onboardNextNotification sessionId }
                onboardOptions {provider status url}
                payProvider
                discountedCcRate{ rate fee amexRate amexFee}
            }
        }
    }
`;
